export default __webpack_public_path__ + "motor-1.3657b89fa76d45e7dcda27d354743b7c.svg";